var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.advises.length)?_c('div',{staticClass:"m-t-15"},[_c('hr'),_vm._m(0),_vm._l((_vm.advises),function(advise,i){return _c('p',{key:i},[_vm._v(" "+_vm._s(advise)+" ")])})],2):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('strong',[_vm._v(" ADVERTENCIAS ")])])
}]

export { render, staticRenderFns }